import type { AnyRouter } from "@tanstack/react-router";

// The app router is created in src/app/App.tsx; this module-level holder lets
// non-React code (Mercure handlers, stores) navigate SPA-style without a reload.
let appRouter: AnyRouter | null = null;

/** Register the app router once at mount — lets non-React code navigate SPA-style. */
export const registerRouter = (router: AnyRouter): void => {
  appRouter = router;
};

/**
 * Navigate to an app route from a non-React context (Mercure handlers, stores…).
 * Accepts internal paths ("/rh/conges/12/view") and same-origin absolute URLs
 * (backend actionUrl payloads). External hosts and protocol-relative URLs are
 * ignored — SPA navigation must never turn into a full reload.
 */
export const navigateToAppPath = (target: string): void => {
  if (!appRouter) return;
  const path = toAppPath(target);
  if (path) void appRouter.navigate({ href: path });
};

const toAppPath = (target: string): string | null => {
  if (target.startsWith("/")) {
    // Reject protocol-relative "//host" sneaking
    return target.startsWith("//") ? null : target;
  }
  try {
    const url = new URL(target);
    return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : null;
  } catch {
    return null;
  }
};
